<template>
    <div class="animated fadeIn"> 
      <b-row>
        <b-col sm="12">
          <b-card>
            <div slot="header">
              <strong>TAT Report</strong>
                  
            </div>        
            <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">            
              <b-row>     
                <b-col sm="4">
                    <b-form-group label="Origin Pincode/City:" :label-cols="4">
                        <b-form-input
                            v-model="originpincode"
                            placeholder="Type origin pincode or city">
                        </b-form-input>
                    </b-form-group>
                    <!--
                    <b-form-group label="Origin Pincode:"  :label-cols="4" >
                        <b-form-input v-model="originpincode" placeholder="Type to Origin Pincode" @input="checklenght(originpincode)"></b-form-input>  
                    </b-form-group>-->
                </b-col>
   
                <b-col sm="4">
                <b-form-group label="Destination Pincode/City:" :label-cols="4">
                    <b-form-input
                        v-model="destinationpincode"
                        placeholder="Type destination Pincode or city">
                    </b-form-input>
                </b-form-group>
                  <!--<b-form-group label="Destination Pincode:"  :label-cols="4" >
                    <b-form-input v-model="destinationpincode" placeholder="ype to Origin Pincode" @input="checklenght(destinationpincode)"></b-form-input>  
                  </b-form-group>-->
                </b-col>
                
                <b-col md="4" class="my-1 text-right">
                  <b-form-group>
                   <b-button type="submit" size="md" variant="primary" @click="showCSV(1)"> Search</b-button>
                    <b-button type="submit" size="md" variant="primary" @click="clear()" style="margin-left: 10px"> clear</b-button>
                    <b-button v-if="totalRows>0" type="submit" variant="primary" size="md" style="margin-left:20px;" @click="downloadCSV">Download </b-button>
                  </b-form-group>
                </b-col>
              </b-row>
            
              <b-row>     
               
                <b-col sm="12" class="text-right  margin-bottom =-13px;" >
                  <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b>   &nbsp;&nbsp;&nbsp;
                </b-col>
              </b-row> 
            </b-form>         
          
              <b-col sm="12" style="overflow:auto;">  
    
              <b-table  show-empty stacked="md" :busy="isBusy"   :items="items" :fields="fields"  :current-page="currentPage"  :per-page="perPage" :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc" :sort-direction="sortDirection"  @filtered="onFiltered" :bordered="bordered"  > 
                  
                  <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                  
               
  
          
          <template slot="lastmodifieddate" slot-scope="row">
            <div>
                {{ row.item.lastmodifieddate | ConvertTime12hour() }}
            </div>
        </template>
          
            </b-table>
          </b-col>
            <b-col md="6" class="my-1" v-if="totalRows>0">
    <paginate
     
      :page-count="noofpages"
      :page-range="10"
      :margin-pages="2"
      :click-handler="clickCallback"
      :prev-text="'Prev'"
      :next-text="'Next'"
      :container-class="'pagination'"
      :page-class="'page-item'">
    </paginate>
            </b-col>
          </b-card>
        </b-col>
      </b-row>    
    </div>
  </template>
  <script>
  import CONSTANTS from "@/utils/constants";
  import Utils from "@/utils";
  import Vue from 'vue'
  export default {
    data: function() {
      return {
        data: [], 
        items:[],    
        selected:'',
        isBusy: false,   
        email:'',
        hubid:'',
        data1:[],
        // perPage:  10,
        pageNum:1,
        noofpages:'',
        pageOptions: [5, 10, 15],
        sortBy: true,
     
        awbno:'',
        agentmaster: [],
        showdata: [],
        selectDateFrom: new Date(),
        selectDateTo:new Date(),
        hubdata:[],
        details:[],
        progressbar:[],
        orderid:[],
       foodproduct:'',
        fields: [
             { key: 'tatid', label: 'SR No.', sortable: true, sortDirection: 'desc' },
             { key: 'tat', label: 'TAT', sortable: true, sortDirection: 'desc' },
             { key: 'originpincode', label: 'Origin Pincode', sortable: true},
             { key: 'origin_city', label: 'Origin City Name', sortable: true},
             { key: 'destinationpincode', label: 'Destination Pincode', sortable: true, sortDirection: 'desc' },
                        { key: 'destination_city', label: 'Destination City Name', sortable: true, sortDirection: 'desc' },
            { key: 'lastmodifiedby', label: 'last modified by', sortable: true },
            { key: 'lastmodifieddate', label: 'last modified date', sortable: true},
          ],
          bordered: true,
          totalRows: 0,
          currentPage: 1,
          perPage:  20,
          pageOptions: [5, 10, 15],
          sortBy: null,
          sortDesc: false,
          sortDirection: 'desc',
          filter: null,
          searching:'',
          originpincode:'',
          destinationpincode:'',
          awbno:'',
          deliverystatus:'',
          infoModal: {
            id: 'info-modal',
            title: '',
            content: ''
          },
          selected_normalorasn : 'rocketbees',
          mpsloadoptions: [
            { value: 'rocketbees', text: 'RocketBees' },
            { value: 'rocketbees_vendor', text: 'RocketBees Vendor' }]
      };
    },
    created: function() {
     
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      this.email=userInfo.sysemailid;
      this.showCSV(this.pageNum);
    },
    methods: {
      checklenght(value){
          console.log("value",value)
          if (value.length==0) {
            this.searching=[]
            this.totalRows=0
            this.showCSV(this.pageNum)
          }
        },
      info(item, shipmentid,index, button) {
        
        this.progressbar  = item;
        this.infoModal.title = 'Shipment Log - '+shipmentid;
        this.infoModal.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
      },
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      validateForm(scope) {},
    
    clickCallback (pageNum)
         {
  
        this.showCSV(pageNum);
      },
       showCSV: function(pagee) {
         var userdata = localStorage.getItem('userData')
         var userInfo = JSON.parse(userdata)

            var csvObj = {
              sysusermasterid:`${userInfo.sysusermasterid}`,
              usertype:`${userInfo.user_type}`,
              page_no:pagee,
              originpincode:this.originpincode,
              destinationpincode:this.destinationpincode,
             };
          this.isBusy = true;   // Show loader
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getTatReport`, csvObj)
            .then(result => {
  
              if (result.body.returnmsg  === 'Successful') {
                  this.items  = result.body.returnvalue[0].parentawblistlist;
                  this.totalRows = result.body.returnvalue[0].totalrecords;  
                   
             this.noofpages=parseInt(this.totalRows)/20;
             
             this.noofpages=Math.ceil( this.noofpages);        
              }else{
               this.showdata = []
                this.items  = [];
                this.totalRows = 0;               
               
              }
            })
            .catch(ex => {
              console.log("error-----", ex);
            }).finally(() => {
            this.isBusy = false;   // Hide loader
        });
      },
  
   downloadCSV:function(){
          document.getElementById("overlay").style.display = "block";
         var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
      
          var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
          var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
          var deliverystatus=(this.deliverystatus!=null)?this.deliverystatus:"";
            var csvObj = {
              sysusermasterid:`${userInfo.sysusermasterid}`,
              usertype:`${userInfo.user_type}`,
              //page_no:pagee,
              originpincode:this.originpincode,
              destinationpincode:this.destinationpincode,
             };
              console.log("JJJJJ",csvObj);
             // return false;
         
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getTatReportCsv`, csvObj)
            .then(result => {
              
            document.getElementById("overlay").style.display = "none";
             if(result.body=="success")
           {
           // alert("Please Check Ur Mail For Downlod Link")
           this.$fire({
                    text:"Please Check Your Mail For Downlod Link",
                    type: "success",
                    timer: 30000
                  }); 
         }
         else
         {
          this.$fire({
                    text:"Can not Download",
                    type: "error",
                    timer: 30000
                  }); 
          // alert("Can not Download");
         }
  
            })
            .catch(ex => {
              console.log("error-----", ex);
            });
      },
  
      
  
  
  
      
      convertArrayOfObjectsToCSV: function(args) {
         var result, ctr, keys, columnDelimiter, lineDelimiter, data;
         data = args.data || null;
         if (data == null || !data.length) {
           return null; var ce
         }
        
  
         columnDelimiter = args.columnDelimiter || ",";
         lineDelimiter = args.lineDelimiter || "\n";
  
         //.slice(0,-4)
         keys = Object.keys(data[0]);
         
         result = "";
         result += keys.join(columnDelimiter);
         result += lineDelimiter;
         data.forEach(function(item) {
         var logdata = item['logdata'];
         var attempt = item['attempt'];
         var allowcheckedin = item['allowcheckedin']
  
          item['pickupcheckintime'] = null;
          item['pickuptime'] = null;
  
          item['orderconfirmedtime'] = null;
          item['deliverytime'] = null;
          item['ordercreationtimestamp'] = "'"+item['ordercreationtimestamp'];
          item['scheduledstarttime'] = "'"+item['scheduledstarttime'];
          item['scheduledendtime'] = "'"+item['scheduledendtime'];
  
           if(logdata!==null){
  
             logdata.forEach(function(itm){
               let mydate = new Date(itm.createddate);
               let month=mydate.getMonth()+1;
               let createddate="'"+mydate.getFullYear()+"-"+month+"-"+mydate.getDate()+" "+mydate.getHours()+":"+mydate.getMinutes();
               switch(itm.process) {
                 case 'BookingDone':
                     if(attempt !== null)
                     {
                         if(attempt == itm.attempt)
                         {
                           item['orderconfirmedtime'] = createddate.toString();
                           break;
                         }
                      }else {
                         item['orderconfirmedtime'] = createddate.toString();
                        break;
                      }
                 case 'OFD':
                      if(attempt !== null)
                     {
                         if(attempt == itm.attempt)
                         {
                           if(allowcheckedin == 'true'){
                             item['pickupcheckintime'] = item['pickupcheckintime1'];
                             item['pickuptime'] = createddate.toString();
                             break;
                           }else {
  
                             item['pickupcheckintime'] = createddate.toString();
                             item['pickuptime'] = createddate.toString();
                             break;
                           }
                         }
                    }else {
                      if(allowcheckedin == 'true'){
                        item['pickupcheckintime'] = item['pickupcheckintime1'];
                        item['pickuptime'] = createddate.toString();
                        break;
                      }else {
                        item['pickupcheckintime'] = createddate.toString();
                        item['pickuptime'] = createddate.toString();
                        break;
                      }
                    }
                 case 'DLV':
                   if(attempt !== null)
                   {
                       if(attempt == itm.attempt)
                       {
                          if(allowcheckedin == 'true'){
                             item['deliverycheckintime'] = item['deliverycheckintime1'];
                             item['deliverytime'] = createddate.toString();
                             break;
                          }else {
                            item['deliverycheckintime'] = createddate.toString();
                            item['deliverytime'] = createddate.toString();
                            break;
                          }
                       }
                  }else {
                      if(allowcheckedin == 'true'){
                         item['deliverycheckintime'] = item['deliverycheckintime1'];
                         item['deli var ceverytime'] = createddate.toString();
                         break;
                      }else {
                        item['deliverycheckintime'] = createddate.toString();
                        item['deliverytime'] = createddate.toString();
                        break;
                      }
                  }
  
                  case 'NDR':
                    if(attempt !== null)
                    {
                        if(attempt == itm.attempt)
                        {
                          item['deliverycheckintime'] = null;
                          item['deliverytime'] = null;
                          break;
                        }
                   }else {
                          item['deliverycheckintime'] = null;
                          item['deliverytime'] = null;
                       break;
                   }
               }
             });
           } else {
             item['deliverytime'] = '';
             item['orderconfirmedtime'] = '';
             item['pickupcheckintime'] = '';
             item['pickuptime'] = '';
           }
           ctr = 0;
          
  
           keys.forEach(function(key) {
            // console.log('--------------------');
            // console.log(key);
                //       console.log('-----datta---------------');
  //&& key!='logdata'
             if (ctr > 0) result += columnDelimiter;
             if (item[key] != null && key!='logdata') {
  
              if(key=='origin'){
                  var str2=item[key];
                  str2=str2.replace('#','');
                  result += '"' +str2 + '"';
               }else{
               result += '"' + item[key] + '"';
               }      
             }           
             
             ctr++;
           });
           result += lineDelimiter;
         });
       //  document.getElementById("loader").style.display = 'none';
  
         return result;
       },
      formatDate: function(date) {
        var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        return [year, month, day].join("-");
  
      },
        clear: function() {
      this.originpincode = '';
      this.destinationpincode = '';
      this.searching="";
      this.deliverystatus="";
      this.selectDateFrom=new Date();
      this.selectDateTo=new Date();
      this.filter="";
      this.selected_normalorasn = 'rocketbees';
      this.showCSV(this.pageNum);
     
     
        
      },
     
  
  
  
  
      MisReportdetails: function(shipmentid,showhide) {
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
          var showhides=showhide;
        
   if(showhides)
   {
  
   }
   else{
        
   
   var awbno = shipmentid;
   
  
    var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
          var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
  
         
          var shippingidobj = {
            fromdate: `${fromdate}`,
            todate:`${formatdateto}`,
            serviceid: `${this.hubid}`,
            shippingid: `${awbno}`,
            hub_id:`${userInfo.pickuplocationmasterid}`,
          };
  
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getmisreportdetails`,shippingidobj)
          .then(result => {
            this.details = result.body.returnvalue;
            console.log(this.details);
          })
          .catch(ex => {
            console.log('error-----', ex)
          });
        }
      },
  
  
  
  
  
    }
  };
  </script>
  
  <style lang="css">
  .popover-container {
    width: 100%;
  }
  .popover-container input {
    -moz-appearance: none;
    -webkit-appearance: none;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border: 1px solid transparent;
    border-radius: 3px;
    -webkit-box-shadow: none;
    box-shadow: none;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    font-size: 1rem;
    height: 2.25em;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    line-height: 1.5;
    padding-bottom: calc(0.375em - 1px);
    padding-left: calc(0.625em - 1px);
    padding-right: calc(0.625em - 1px);
    padding-top: calc(0.375em - 1px);
    position: relative;
    vertical-align: top;
    background-color: white;
    border-color: #dbdbdb;
    color: #363636;
    -webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
    box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
    max-width: 100%;
    width: 100%;
  }
  .table tr th {
    color: #fff !important;
    padding: .2rem!important;
  }
  .table thead,
  .table thead tr:hover {
    background: #333 !important;
  }
  .table button {
    background: #b0c4de !important;
    color: #000 !important;
  }
  .table tr:hover {
    background: #efefef;
  }
  tbody tr:nth-child(even) {
    background: #f2f2f2;
  }
  tbody tr:nth-child(odd) {
    background: #fff;
  }
  .registerbox {
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
    width: 1244px;
    background-color: #fff;
  }
  hr {
    margin-bottom: 0px;
  }
  .error {
    color: red;
  }
  button.editbtn {
    border: none;
    background: transparent !important;
  }
  .label {
    text-align: left;
  }
  .select {
    width: 100%;
  }
    .nameOfTheClass {
     max-width: 450px !important;
  }
  .orderidClass{
     max-width: 110px !important;
  }
  .awbClass{
    max-width: 110px !important;
  }
  .statusClass{
   max-width: 110px !important; 
  }
  .desitnationClass{
    max-width: 110px !important; 
  }
  .countryClass{
   max-width: 60px !important;  
  }
  .pickupClass{
    max-width: 100px !important; 
  }
  
  
  /* Safari */
  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  /*tbody tr:nth-child(odd) {
      background: darkgray !important;
  }*/
  </style>
  
